import React from 'react';
// import sectionImage from '../assets/imagelittle.png'; // Bild-Pfad anpassen
import "./Infosection.css"

interface InfoSectionProps {
    title: string;
    imageSrc: string; // Hier kommt der Pfad zum Bild rein
    reversed?: boolean;
    description: React.ReactNode;
}

const InfoSection = ({ title, description, imageSrc, reversed }: InfoSectionProps) => {
    return (
        <section className={`custom-info-section ${reversed ? 'reversed' : ''}`}>
            <div className="info-grid">
                <div className="image-wrapper">
                    <div className="frame">
                        {/* imageSrc wird hier dynamisch eingesetzt */}
                        <img src={imageSrc} alt={title}/>
                    </div>
                </div>
                <div className="text-wrapper">
                    {/* title wird hier dynamisch eingesetzt */}
                    {/*<h2>{title}</h2>*/}
                    <div className="divider-wrapper">
                        {/*<span className="ornamental">q</span>*/}
                    </div>
                    {/* 'A' ist hier der Platzhalter für dein Symbol */}
                    <div className="divider"></div>
                    {/* description wird hier dynamisch eingesetzt */}
                    <p className="highlight-text">{description}</p>
                </div>
            </div>
        </section>
    );
};

export default InfoSection;